export class Controller {

    /** @ngInject */
    constructor($rootScope, $uibModal, CompanyUserResource) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CompanyUserResource = CompanyUserResource;
    }

    $onInit() {
        this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.isUser = this.account.roles.includes('ROLE_USER');
    }

    companyRoleIconClass(role) {
        return ({
            'APPLICATION_ADMIN': 'fa fa-list-alt',
            'DEVELOPER_ADMIN': 'fa fa-wrench',
            'ORGANIZATION_ADMIN': 'fa fa-sitemap',
            'READ_ONLY_ADMIN': 'fa fa-eye',
            'SUPER_ADMIN': 'fa fa-building',
            'SAASPASS_ADMIN': 'fa fa-building',
        })[role];
    }

    onUserCompaniesDropdownToggle() {
        this.userCompaniesDropdownSearchKey = '';
    }

    logAdminDevSwitchToCompany(companyId) {
        this.$rootScope.logCompanyAccessed$ = this.CompanyUserResource.logCompanyAccessed(companyId)
    }

    showYouAreNotCompanyAdminMessage() {
        this.$uibModal.open({component: 'youAreNotCompanyAdmin'});
    }

    showRecoveryReminder() {
        return !this.account.hasRecovery
            && !this.account.recoveryTurnedOff
            && this.account.recoveryReminder
            && !this.account.roles.includes('ROLE_HARD_TOKEN_USER')
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/user.controller.js